<template>
    <div class="withdraw">
        <div class="glodApply">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>{{this.$t('home.withDraw')}}</span>
                </div>
                <div class="applyForm">
                    <el-row :gutter="15">
                        <el-form :model="applyForm" ref="applyForm" :rules="applyRules">
                            <el-col :span="12" :class="{floatRightStyle: $i18n.locale === 'ae'}">
                                <el-form-item :label="$t('home.holderName')" prop="login_holder">
                                    <el-input v-model="applyForm.login_holder" :placeholder="$t('home.enterHolderName')" disabled></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('home.accountNumber')" prop="username">
                                    <el-input v-model="applyForm.username" :placeholder="$t('home.enterAccountNumber')" disabled></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('home.currency')" prop="currency">
                                    <el-select v-model="applyForm.currency" clearable :placeholder="$t('home.selectCurrency')">
                                        <el-option v-for="item in currencyOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('home.amount')" prop="amount">
                                    <el-input v-model="applyForm.amount" :placeholder="$t('home.enterAmount')"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_bank_account')" prop="card_number">
                                    <el-input v-model="applyForm.card_number" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_bank_name')" prop="bank_name">
                                    <el-input v-model="applyForm.bank_name" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_beneficiary')" prop="beneficiary_name">
                                    <el-input v-model="applyForm.beneficiary_name" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_swift')" prop="swift_code">
                                    <el-input v-model="applyForm.swift_code" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_receving')" prop="info_type" class="aeParentheses">
                                    <el-select v-model="applyForm.info_type" clearable @change="recevingChange">
                                        <el-option v-for="(v,i) in recevingOptions" :key="i" :label="v.label" :value="v.value" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" prop="info_value" ref="info_value">
                                    <el-input v-model="applyForm.info_value" :placeholder="$t('withdraw.draw_corres')" :disabled="!applyForm.info_type"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('withdraw.draw_bank_address')" prop="bank_address1">
                                    <el-input v-model="applyForm.bank_address1" :placeholder="$t('withdraw.draw_add_1')"></el-input>
                                </el-form-item>
                                <el-form-item label="" prop="bank_address2">
                                    <el-input v-model="applyForm.bank_address2" :placeholder="$t('withdraw.draw_add_2')"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_country')" prop="bank_country">
                                    <el-input v-model="applyForm.bank_country" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_city')" prop="bank_city">
                                    <el-input v-model="applyForm.bank_city" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_post_code')" prop="post_code">
                                    <el-input v-model="applyForm.post_code" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item label="" prop="require_intermediary" style="text-align: left;">
                                    <el-checkbox v-model="applyForm.require_intermediary" :label="$t('withdraw.draw_intermediary')" border @change="intermediaryChange"></el-checkbox>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_inter_name')" prop="intermediary_bank_name" ref="intermediary_bank_name">
                                    <el-input v-model="applyForm.intermediary_bank_name" placeholder="" :disabled="!applyForm.require_intermediary"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_country')" prop="intermediary_country_code" ref="intermediary_country_code">
                                    <el-input v-model="applyForm.intermediary_country_code" placeholder="" :disabled="!applyForm.require_intermediary"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_swift')" prop="intermediary_swift_code" ref="intermediary_swift_code">
                                    <el-input v-model="applyForm.intermediary_swift_code" placeholder="" :disabled="!applyForm.require_intermediary"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_add_info')" prop="additional_information">
                                    <el-input v-model="applyForm.additional_information" placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form>
                    </el-row>
                    <div class="applySubmit">
                        <el-checkbox v-model="defaultInfo" :label="$t('home.setDefaultWithdraw')" border></el-checkbox>
                        <el-button @click="resetForm('applyForm')">{{$t('home.reset')}}</el-button>
                        <el-button type="primary" :loading="submitLoading" @click="applySubmit">{{$t('home.submit')}}</el-button>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="applyInfo">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-row :gutter="15">
                        <el-col :span="24">
                            <el-col :span="6" :class="{floatRightStyle: $i18n.locale === 'ae'}">
                                <span>{{$t('home.ApplicationInfo')}}</span>
                            </el-col>
                            <el-col :span="18" style="text-align:right;">
                                <el-select v-model="withdrawStatus" @change="selectWithdraw" clearable :placeholder="$t('home.selectAppStatus')">
                                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-col>
                        </el-col>
                    </el-row>
                    <!-- <span :class="{floatRightStyle: $i18n.locale === 'ae'}">{{$t('home.ApplicationInfo')}}</span>
                    <el-select v-model="withdrawStatus" @change="selectWithdraw" clearable :placeholder="$t('home.selectAppStatus')">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select> -->
                </div>
                <div class="applyTable" v-loading="applyTableLoading">
                    <el-table :data="tableData" style="width: 100%" stripe border>
                        <el-table-column v-for="(item,index) in tableHead" :key="index" :label="item.labelName" :prop="item.propName" :min-width="item.width" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="item.propName == 'STATUS'">
                                    <span v-show="scope.row.STATUS === '0'">
                                        <el-tag size="small">{{$t('home.inHand')}}</el-tag>
                                    </span>
                                    <span v-show="scope.row.STATUS === '1'">
                                        <el-tag  type="success" size="small">{{$t('home.figureOut')}}</el-tag>
                                    </span>
                                    <span v-show="scope.row.STATUS === '2'">
                                        <el-tooltip class="item" effect="dark" :content="scope.row.UPDATE_REASON ? scope.row.UPDATE_REASON : $t('other.noReason')" placement="top" popper-class="user-tooltip">
                                            <el-tag  type="danger" size="small">{{$t('home.rejected')}}</el-tag>
                                        </el-tooltip>
                                    </span>
                                    <span v-show="scope.row.STATUS === '3'">
                                        <el-tag type="warning" size="small">{{$t('home.canceled')}}</el-tag>
                                    </span>
                                </span>
                                <span v-else>{{scope.row[item.propName] ? scope.row[item.propName] : '-'}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="applyPage">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10,15,20,30 ,50,100,200]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </el-card>
        </div>
    </div>
</template>
<script>
import { addWithdrawInfo , withdrawList , withdrawDefault , getCharge } from "@/api/money/money"
export default {
    name:'withdraw',
      data() {
        return {
            applyForm: {
                login_holder: '',
                username: '',
                currency: '',
                amount: '',
                card_number: '',
                bank_name: '',
                beneficiary_name: '',
                swift_code: '',
                info_type: '',
                info_value: '',
                bank_address1: '',
                bank_address2: '',
                bank_country: '',
                bank_city: '',
                post_code: '',
                require_intermediary: false,
                intermediary_bank_name: '',
                intermediary_country_code: '',
                intermediary_swift_code: '',
                additional_information: '',
            },
            full_name: '',
            currencyOptions: [
                {
                    label: 'USD($)',
                    value: 1
                }
            ],
            withdrawStatus: '',
            statusOptions: [
                {
                    label: this.$t('home.inHand'),
                    value: 0
                },
                {
                    label: this.$t('home.figureOut'),
                    value: 1
                },
                {
                    label: this.$t('home.rejected'),
                    value: 2
                },
                {
                    label: this.$t('home.canceled'),
                    value: 3
                }
            ],
            applyRules: {
                /* login_holder: [
                    { required: true, message: '输入账户持有者姓名', trigger: 'blur' }
                ],
                username: [
                    { required: true, message: '输入交易账户号码', trigger: 'blur' }
                ], */
                currency: [
                    { required: true, message: this.$t('home.selectCurrency'), trigger: 'blur' }
                ],
                amount: [
                    { validator: this.validateAmount,required: true, trigger: 'blur' }
                ],
                /* full_name: [
                    { required: true, message: '收款人姓名', trigger: 'blur' }
                ], */
                /* card_number: [
                  { required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' },
                  { pattern: /^\d{15,45}$/ ,message: this.$t('withdraw.least_fifteen'), trigger:['blur']}
                ], */
                card_number: [
                    {
                        required: true,
                        trigger: ["blur"],
                        validator: this.validateBankCard
                    }
                ],
                bank_name: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                swift_code: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                info_value: [{ required: false, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                bank_address1: [
                { required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }
                ],
                bank_country: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                bank_city: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                post_code: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                intermediary_bank_name: [{ required: false, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                intermediary_country_code: [{ required: false, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                intermediary_swift_code: [{ required: false, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
            },
            defaultInfo: 0,
            tableData: [],
            tableHead: [
                { propName: 'LOGIN',labelName: this.$t('home.accountNumber'),width: '130' },
                { propName: 'LOGIN_HOLDER',labelName: this.$t('home.holderName'),width: '160' },
                { propName: 'FULL_NAME',labelName: this.$t('home.payeeName'),width: '100' },
                { propName: 'AMOUNT',labelName: this.$t('home.amount'),width: '100' },
                { propName: 'CHARGE',labelName: this.$t('home.charge'),width: '100' },
                /* { propName: 'BANK_PROVINCE',labelName: this.$t('home.province'),width: '100' },
                { propName: 'BANK_CITY',labelName: this.$t('home.city'),width: '100' },
                { propName: 'BANK_NAME',labelName: this.$t('home.bankName'),width: '120' },
                { propName: 'BANK_BRANCH',labelName: this.$t('home.bankBranch'),width: '120' },
                { propName: 'CARD_NUMBER',labelName: this.$t('home.bankAccount'),width: '120' }, */
                { propName: 'CARD_NUMBER',labelName: this.$t('withdraw.draw_bank_account'),width: '120' },
                { propName: 'BANK_NAME',labelName: this.$t('withdraw.draw_bank_name'),width: '100' },
                { propName: 'BENEFICIARY_NAME',labelName: this.$t('withdraw.draw_beneficiary'),width: '130' },
                { propName: 'SWIFT_CODE',labelName: this.$t('withdraw.draw_swift'),width: '180' },
                { propName: 'BANK_COUNTRY',labelName: this.$t('withdraw.draw_country'),width: '120' },
                { propName: 'BANK_CITY',labelName: this.$t('withdraw.draw_city'),width: '120' },
                { propName: 'IBAN_CODE',labelName: 'IBAN',width: '100',isShow: true },
                { propName: 'ABA',labelName: 'ABA',width: '100',isShow: true },
                { propName: 'SORT_CODE',labelName: 'Sort Code',width: '100',isShow: true },
                { propName: 'BSB',labelName: 'BSB',width: '100',isShow: true },
                { propName: 'INTERMEDIARY_BANK_NAME',labelName: 'Intermediary Bank Name',width: '180',isShow: true },
                { propName: 'INTERMEDIARY_COUNTRY_CODE',labelName: 'Intermediary Bank Country',width: '200',isShow: true },
                { propName: 'INTERMEDIARY_SWIFT_CODE',labelName: 'Intermediary Swift Code',width: '180',isShow: true },
                { propName: 'STATUS',labelName: this.$t('home.status'),width: '90' },
                { propName: 'CREATE_TIME',labelName: this.$t('home.regDate'),width: '150' }
            ],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            applyTableLoading: false,
            submitLoading: false,
            predictCharge: 0
        }
    },
    computed: {
        userInfo(){
            return JSON.parse(sessionStorage.getItem('user_info'));
        },
        /* 记录登录用户的余额 */
        login_balance(){
            let userSession = JSON.parse(sessionStorage.getItem('user_info'));
            return userSession.BALANCE;
        },
        recevingOptions(){
            return [
                { label: 'IBAN(EU)', value: 'iban' },
                { label: 'ABA(US)', value: 'aba' },
                { label: 'Sort Code(UK)', value: 'sort_code' },
                { label: 'BSB(Australia)', value: 'bsb' }
            ]
        },
    },
    mounted(){
        this.applyForm.login_holder = this.userInfo.NAME;
        this.applyForm.username = this.userInfo.LOGIN;
        this.full_name = this.userInfo.NAME_CN;
        this.reloadWithdrawList();
        this.getDefaultWithdraw();
        this.getChargeInfo();
    },
    methods: {
        /* 银行卡验证 */
        validateBankCard(rule, value, callback) {
        if (value === "") {
            callback(new Error(this.$t("withdraw.isRequired")));
        } else {
            if(isNaN(value)){
                callback(new Error(this.$t("other.formatError")));
            }else{
            if(!/^\d{4,10000}$/.test(value)){
                callback(new Error(this.$t("other.formatError")));
            }else {
                callback();
            }
            }
        }
        },
        recevingChange(v){
            this.$refs.info_value.resetField();
            this.applyRules.info_value[0].required = v ? true : false;
        },
        intermediaryChange(v){
            this.$refs.intermediary_bank_name.resetField();
            this.$refs.intermediary_country_code.resetField();
            this.$refs.intermediary_swift_code.resetField();
            this.applyRules.intermediary_bank_name[0].required = this.applyRules.intermediary_country_code[0].required = this.applyRules.intermediary_swift_code[0].required = v;
        },
        /* 金额验证 */
        validateAmount(rule, value, callback){
            if(value === ''){
                callback(this.$t('home.enterAmount'));
            }else{
                var ptn = /^\d+(?=\.{0,1}\d+$|$)/;
                var res = ptn.test(value);
                if(!res){
                    callback(this.$t('placeholder.enterCorrectMoney'));
                }else{
                    if(value > Number(this.login_balance)){
                        callback(this.$t('placeholder.lackBalance'));
                    }else{
                        callback();
                    }
                }
            }
        },
        getChargeInfo(){
            getCharge().then( v => {
                this.predictCharge = v.data.charge;
            })
        },
        /* 重置表单 */
        resetForm(formName) {
            $('.routerView').scrollTop(0);
            this.$refs[formName].resetFields();
        },
        /* 提交表单 */
        applySubmit(){
            /* if(!this.full_name){
                this.$message({
                    message: this.$t('home.addCnName'),
                    type: 'warning'
                })
                return;
            } */
            this.$refs.applyForm.validate( (valid) => {
                if(valid){
                    this.applyForm[this.applyForm.info_type] = this.applyForm.info_value;
                    let params = {
                        full_name: this.full_name,
                        /* amount: Number(this.applyForm.amount), */
                        default: Number(this.defaultInfo),
                        ...this.applyForm,
                        require_intermediary: this.applyForm.require_intermediary ? 1 : 0
                    }
                    this.submitLoading = true;
                    addWithdrawInfo(params).then( v => {
                        this.submitLoading = false;
                        if(v.code == '100000'){
                            this.$message({
                                message: this.$t('home.noBalance'),
                                type: 'warning'
                            });
                        }else if(v.code == '100002'){
                            this.$message({
                                message: this.$t('home.unfinished'),
                                type: 'warning'
                            });
                        }else if(v.code == 0){
                            this.$message({
                                message: this.$t('home.withdrawSuccess'),
                                type: 'success'
                            });
                            this.scrollToBottom();
                            this.reloadWithdrawList();
                        }else{
                            this.$message({
                                message: v.msg,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        /* 获取该用户默认出金信息 */
        getDefaultWithdraw(){
            withdrawDefault().then( v => {
                if(v.code == 0){
                    if(v.data.row.length > 0){
                        let tData = v.data.row[0];
                        this.applyForm.currency = tData.CURRENCY;
                        this.applyForm.card_number = tData.CARD_NUMBER;
                        this.applyForm.bank_name = tData.BANK_NAME;
                        this.applyForm.beneficiary_name = tData.BENEFICIARY_NAME;
                        this.applyForm.swift_code = tData.SWIFT_CODE;
                        this.applyForm.bank_address1 = tData.BANK_ADDRESS1;
                        this.applyForm.bank_address2 = tData.BANK_ADDRESS2;
                        this.applyForm.bank_country = tData.BANK_COUNTRY;
                        this.applyForm.bank_city = tData.BANK_CITY;
                        this.applyForm.post_code = tData.POST_CODE;
                        this.applyForm.require_intermediary = tData.REQUIRE_INTERMEDIARY == 1 ? true: false;
                        this.applyForm.intermediary_bank_name = tData.INTERMEDIARY_BANK_NAME;
                        this.applyForm.intermediary_country_code = tData.INTERMEDIARY_COUNTRY_CODE;
                        this.applyForm.intermediary_swift_code = tData.INTERMEDIARY_SWIFT_CODE;
                        this.applyForm.additional_information = tData.ADDITIONAL_INFORMATION;
                        if(tData.IBAN_CODE || tData.ABA || tData.SORT_CODE || tData.BSB){
                            if(tData.IBAN_CODE){
                                this.applyForm.info_type = 'iban';
                                this.applyForm.info_value = tData.IBAN_CODE;
                            }
                            if(tData.ABA){
                                this.applyForm.info_type = 'aba';
                                this.applyForm.info_value = tData.ABA;
                            }
                            if(tData.SORT_CODE){
                                this.applyForm.info_type = 'sort_code';
                                this.applyForm.info_value = tData.SORT_CODE;
                            }
                            if(tData.BSB){
                                this.applyForm.info_type = 'bsb';
                                this.applyForm.info_value = tData.BSB;
                            }
                        }
                        
                    }
                }else{
                    this.$message({
                        message: v.msg,
                        type: 'error'
                    });
                }
            })
        },
        /* 出金申请列表 */
        reloadWithdrawList(){
            let params = {
                page: this.currentPage,
                page_size: this.pageSize,
                status: this.withdrawStatus
            }
            this.applyTableLoading = true;
            withdrawList(params).then( v => {
                this.applyTableLoading = false;
                if(v.code == 0){
                    this.tableData = v.data.row;
                    this.total = v.data.total*1;
                }else{
                    this.$message({
                        message: v.msg,
                        type: 'error'
                    });
                }
            })
        },
        selectWithdraw(){
            this.scrollToBottom();
            this.reloadWithdrawList();
        },
        handleSizeChange(v){
            this.$nextTick( () => {
                this.scrollToBottom();
            })
            this.currentPage = 1;
            this.pageSize = v;
            this.reloadWithdrawList();
        },
        handleCurrentChange(v){
            this.currentPage = v;
            this.reloadWithdrawList();
        },
        scrollToBottom(){
            //$('.routerView').scrollTop($('.routerView')[0].scrollHeight);
            $('.routerView').scrollTop(610);
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.withdraw{
    height: 100%;
    /* overflow: auto; */
    .applyForm{
        .applySubmit{
            text-align: right;
            padding-top: 15px;
        }
        /* .chargeNumber{
            color: red;
        } */
    }
    .applyInfo{
        margin-top: 20px;
        margin-bottom: 20px;
        .applyPage{
            margin-top: 20px;
            text-align: right;
        }
    }
}
</style>
<style>
.applyForm .el-select{
    width: 100%;
}
.applySubmit .el-button+.el-button{
    margin-left: 0px;
}
/* .applyTable .el-table tr{
    cursor: pointer;
} */
.applyInfo .el-card__header{
    padding: 8px 20px;
    line-height: 40px;
}
.user-tooltip{
	max-width: 20%;
} 
.friendShip .el-form-item__content{
    margin-left: 0px !important;
    line-height: 15px;
    /* background: #d8dce5; */
    color: #bbb;
    padding: 0px 5px 5px 15px;
    border-radius: 10px;
    font-size: 12px;
}
/* .sortCodeItem{
    margin-bottom: 10px !important;
} */
</style>




// WEBPACK FOOTER //
// withdraw.vue?bc45479e